import { MessageApiProvider } from "./contexts/MessageContext";
import { ApiProvider } from "./contexts/SessionContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.css"
import { ToastContainer } from "react-toastify";
import { LoaderProvider } from "./hooks/useLoader";
import { Routes } from "./routes/Routes";
import { logPageView } from "./utils/analytics";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

localStorage.removeItem('@assistamais');
sessionStorage.removeItem('@assistamais');
const clientId = '175857597463-qsf2pu0o23camne76motu6r3rtf6m9sm.apps.googleusercontent.com';

function App() {
  const history = useHistory();

  useEffect(() => {
    // no mount, dispara o primeiro pageview
    logPageView(window.location.pathname + window.location.search);

    // escuta todas as navegações via history.push/replace
    const unlisten = history.listen(({ pathname, search }) => {
      logPageView(pathname + search);
    });
    return () => unlisten();
  }, [history]);

  return (
    <Provider store={store}>
      <LoaderProvider>
        <ApiProvider>
          <MessageApiProvider>
            <GoogleOAuthProvider clientId={clientId}>
              <Routes />
            </GoogleOAuthProvider>
          </MessageApiProvider>
        </ApiProvider>
      </LoaderProvider>
      <ToastContainer 
        position="top-right"
        theme="colored"
      />
    </Provider>
  );
}

export default App;
